import { computed, type Ref, ref } from "vue"

const messageStateMap = new Map<string, Ref<any>>()

const getOrCreateState = <T>(key: string, init: () => T): Ref<T> => {
  if (typeof useState === "function") {
    return useState<T>(key, init)
  }
  if (!messageStateMap.has(key)) {
    messageStateMap.set(key, ref(init()))
  }
  return messageStateMap.get(key)!
}

export const useMessage = () => {
  const message = getOrCreateState<string>("app_message", () => "")

  const setMessage = (msg: string) => {
    message.value = msg
  }

  const clearMessage = () => {
    message.value = ""
  }

  const existsMessage = computed(() => message.value !== "")

  return {
    message,
    setMessage,
    clearMessage,
    existsMessage,
  }
}
